import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Shared light/dark toggle. Source of truth is `localStorage.darkMode`
 *  ('true'/'false'); the inline script in index.html applies the class on
 *  first paint so we never flash the wrong theme. */
export const ThemeToggle = () => {
  const [dark, setDark] = useState(() => {
    if (typeof window === "undefined") return true;
    const s = localStorage.getItem("darkMode");
    if (s === null) return true;
    return s === "true";
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (dark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("darkMode", String(dark));
  }, [dark]);

  return (
    <Button
      variant="ghost"
      size="icon"
      className="rounded-full"
      onClick={() => setDark((d) => !d)}
      data-testid="dark-mode-toggle"
      title={dark ? "Switch to light" : "Switch to dark"}
      aria-label="Toggle dark mode"
    >
      {dark ? (
        <Sun className="w-5 h-5" strokeWidth={1.5} />
      ) : (
        <Moon className="w-5 h-5" strokeWidth={1.5} />
      )}
    </Button>
  );
};
